$(function () {

    /**
     * PASSWORD
     */

    $(document).on('click', '.toggle-password', (e) => {
        e.preventDefault();
        var input = $($(e.currentTarget).attr("toggle"));
        if (input.attr("type") == "password") {
            input.attr("type", "text");
        } else {
            input.attr("type", "password");
        }
    });

    $('.password-constraint').each(function() {
        var input = $(this).find('input[type="password"]');
        var help = $(this).next('.password-constraint__help');
        var length = help.find('.password-constraint__length');
        var lowercase = help.find('.password-constraint__lowercase');
        var digit = help.find('.password-constraint__digit');
        input.keyup(function () {
            var value = input.val();
            // Length
            if (value.length >= 6) {
                length.removeClass('invalid').addClass('valid');
            } else {
                length.removeClass('valid').addClass('invalid');
            }
            // Lowercase
            if (value.match(/[a-z]/g)) {
                lowercase.removeClass('invalid').addClass('valid');
            } else {
                lowercase.removeClass('valid').addClass('invalid');
            }
            // Digit
            if (value.match(/[0-9]/g)) {
                digit.removeClass('invalid').addClass('valid');
            } else {
                digit.removeClass('valid').addClass('invalid');
            }
        });
    });

    /**
     * FIN - PASSWORD
     */

});

